// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "button{border:none}.link-5DXGk{text-decoration:none}.textActive-5kk8s{color:#00d88f;font-weight:500 !important;letter-spacing:1px;font-size:13px;text-transform:uppercase}.textInactive-FOpsI{color:orange}.textInfo-R1Oro{color:hsla(0,0%,100%,.69)}.activePoint-KmiSF{background:#00d88f;min-width:11px;min-height:11px;border-radius:50%;animation:blink-9Ja2X 3s infinite}@keyframes blink-9Ja2X{0%{opacity:1}50%{opacity:.2}100%{opacity:1}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"link": "link-5DXGk",
	"textActive": "textActive-5kk8s",
	"textInactive": "textInactive-FOpsI",
	"textInfo": "textInfo-R1Oro",
	"activePoint": "activePoint-KmiSF",
	"blink": "blink-9Ja2X"
};
export default ___CSS_LOADER_EXPORT___;
